'use client';

import { Button } from '../button';

interface ICalendarFooterProps {
  isDisabled?: boolean;
  labelApply: string;
  labelClear: string;
  onApply: () => void;
  onClear: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * This renders a footer for the calendar picker component.
 */
export function CalendarFooter({
  isDisabled,
  labelApply,
  labelClear,
  onApply,
  onClear,
}: ICalendarFooterProps) {
  return (
    <div className="flex items-center justify-end gap-2 border-t p-2">
      <Button disabled={isDisabled} onClick={onClear} size="sm" variant="ghost">
        {labelClear}
      </Button>
      <Button
        disabled={isDisabled}
        onClick={onApply}
        size="sm"
        variant="default"
      >
        {labelApply}
      </Button>
    </div>
  );
}

interface IRenderCalendarFooterProps {
  clearRange: () => void;
  isDisabled: boolean;
  labelApply: string;
  labelClear: string;
}

interface IFooterProps {
  close: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * Curried component to render the calender without rerendering within
 * the calendar body.
 */
export function RenderCalendarFooter({
  isDisabled,
  clearRange,
  labelApply,
  labelClear,
}: IRenderCalendarFooterProps) {
  return function Footer({ close }: IFooterProps) {
    const handleClear = () => {
      clearRange();
      close();
    };

    const handleApply = () => {
      close();
    };

    return (
      <CalendarFooter
        isDisabled={isDisabled}
        labelApply={labelApply}
        labelClear={labelClear}
        onApply={handleApply}
        onClear={handleClear}
      />
    );
  };
}
